
import React from "react";
import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import QuizBanner from "./page/QuizBanner";
import Assessment from "./page/Assessment";

function App() {
  return (
    <Router>
      <Routes>
        <Route path="/" element={<QuizBanner />} />
        <Route path="/assessment" element={<Assessment />} />
      </Routes>
    </Router>
  );
}

export default App;
